export const COPY = {
  resetPassword: 'Reset password',
  contactUs: 'If you do not receive a reset email, please contact support:',
  email: 'etpmanagers@absa.africa',
  error: 'Something went wrong, please try again',
  resetSent: (username: string) =>
    `We will try to send password reset instructions to the e-mail address associated with the user ${username} if it exists in our records.`
}
